module.exports = __webpack_public_path__ + "joined-the-club-white.svg?f18be5be4f97a4746f9ad58b69ff9e30";